/*
 * Copyright (c) 2020 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */

import GlobalStore from "../GlobalStore/GlobalStore";
import axiosInstance from "./ForgeAxiosInstance";
import {ISiteDetails} from "./IGatewayRegistrationInterfaces";

/**
 * This store takes care of registering the gateway with the tenant account.
 */
export default class GatewayValidationStore extends GlobalStore {

  /**
   * Check if the site type is `Intelligent Gateway`.
   * Gateway registration can only happen for sites of type "Intelligent Gateway"
   */
  checkSiteIsIntelligentGateway = (siteDetails: ISiteDetails) => {
    let envVars = this.envVariables;
    let siteDetailsURL =
      `${envVars.PORTAL_API_GATEWAY_URL}${this.GATEWAY_SITE_DETAILS_URL(siteDetails.siteId)}`;
    return axiosInstance.getInstance()({
      url: siteDetailsURL,
      method: 'GET',
      headers: {
        'organizationid': siteDetails.siteId
      }
    }).then((res) => {
      let siteDetailsResponse = res.data;
      if (!!siteDetailsResponse && siteDetailsResponse.StatusCode === 200) {
        let siteDetails = siteDetailsResponse.Result;
        return (siteDetails.SiteType === "GATEWAY");
      }
      return false;
    });
  };

  /**
   * Check if the site already has a gateway associated
   * This is for the pre-registered snap cae where it is likely that the gateway is associated
   * already to a site using either DIY or Forge Portal.
   */
    // @Todo Implement the API to check if the gateway mapping exists for a site.
  checkIfGatewayAlreadyAssociated = () => {
    return Promise.resolve(false);
  };

  private readonly GATEWAY_SITE_DETAILS_URL = (siteId: string) => `/api/Settings/${siteId}?section=general`;
}
